import React from "react";
import Button from "../Button/Button";
import "./ChatText.scss";
import DeviceContext from "../../Services/identifyDevice";
import callSupport from "../../../assets/icons/call.png";
import InfoModal from "../InfoModal/InfoModal";
import PanSample from "../../../assets/pan_sample.jpg";
import { pan } from "../../utils/regex";

export interface ChatTextProps {
  className?: string;
  panPageFlag?: boolean;
}

const ChatText: React.FC<ChatTextProps> = (props) => {
  const [instantHelpReadMoreFlag, setInstantHelpReadMoreFlag] =
    React.useState<boolean>(false);

  const triggerRef = React.useRef<HTMLButtonElement>(null);
  const closeBtnRef = React.useRef<HTMLButtonElement>(null);

  React.useEffect(() => {
  }, [DeviceContext().isMobile]);

  React.useEffect(() => {
    if (instantHelpReadMoreFlag) {
      closeBtnRef.current?.focus();
    } else {
      triggerRef.current?.focus();
    }
  }, [instantHelpReadMoreFlag]);

  React.useEffect(() => {
    if (!instantHelpReadMoreFlag) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        setInstantHelpReadMoreFlag(false);
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [instantHelpReadMoreFlag]);

  const readMoreFlagToggle = () => {
    setInstantHelpReadMoreFlag((prev) => !prev);
  };


  return (
    <div>
      {props.panPageFlag ? (
        <div className="">
          {DeviceContext().isMobile ? (
            <div>
              {instantHelpReadMoreFlag ? (
                <div className="instant-help-modal-mobile" id="instant-help-mobile-dialog">
                  <InfoModal
                    width={DeviceContext().isMobile ? "400px" : "354px"}
                    ariaLabelledBy="instant-help-mobile-title"
                  >
                    <div className="" style={{ padding: "8px" }}>
                      <div style={{ marginBottom: "28px" }}>
                        <div
                          className=""
                          style={{ float: "left", width: "95%" }}
                        >
                          <h2
                            id="instant-help-mobile-title"
                            className="blue text-center"
                            style={{ color: "#434343" }}
                          >
                            Instant Help!!!
                          </h2>
                        </div>
                        <button
                          ref={closeBtnRef}
                          type="button"
                          className="instant-help-close-btn"
                          aria-label="Close instant help"
                          onClick={readMoreFlagToggle}
                        >
                          x
                        </button>
                      </div>
                      <div className="instant-help-body">
                        <p>
                        We hope you're ready to begin your onboarding journey
                        with us using your PAN Card. Follow these simple steps
                        to ensure a smooth process:
                        </p>
                        <h3>Are you handy with your PAN Card:</h3>
                        <ul className="instant-help-ul">
                          <li>Have your PAN card handy.</li>
                          <li>
                            Make sure to upload it in a horizontal format for
                            clear visibility, as it will be shared with the KYC
                            Registration Agency (KRA) if not KRA.
                          </li>
                        </ul>
                        <h3>Why do we require PAN Card?</h3>
                        <p className="instant-help-note">
                           Your PAN card is needed to verify your name with
                          the Income Tax website.
                        </p>
                        <h3> How to Upload a PAN Card?</h3>
                        <ul className="instant-help-ul">
                          <li>
                            Upload a color image copy of your PAN card, ensure
                            that it is properly cropped in a horizontal format.
                          </li>
                          <li>
                            Our system will automatically read and fill in your
                            First Name, Middle Name, Last Name, Date of Birth,
                            and PAN Card Number.
                          </li>
                          <li>
                            If any information is incorrect, you can edit it
                            before submitting.
                          </li>
                        </ul>
                        <h3>Information Verification:</h3>
                        <p>
                          The data will be sent to the Income Tax Department for
                          verification. Verification is necessary to open your
                          account.
                        </p>
                        <p>Handling Name Mismatch Errors:</p>
                        <ul className="instant-help-ul">
                          <li>
                            If you get a "Name not Matched" error, you can
                            verify your name using this link:{" "}
                            <a
                              href="https://eportal.incometax.gov.in/iec/foservices/#/pre-login/verifyYourPAN"
                              target="_blank"
                            >
                              Verify Your PAN
                            </a>
                          </li>
                          <li>
                            {" "}
                            Enter the Name as per Aadhar / Bank / Name that you
                            have entered while entering PAN Card.
                          </li>
                        </ul>
                        <p>
                           Note: This may happen only if you have changed your
                          Name Post Marriage or Pan Card is issued prior to 2012
                          as per Income Tax Authorities.
                        </p>
                        <h3>Tips for Smooth Processing:</h3>
                        <ul>
                          <li>
                            Always upload the original or a colour scanned image
                            of your PAN card.
                          </li>
                          <li>
                            Ensure that the Name, Date of Birth, and Photo on
                            your PAN card are clearly visible.
                          </li>
                        </ul>
                        {/* <div className="text-center">
                          <img
                            className="pan_image_sample"
                            src={PanSample}
                            alt={"pan-sample"}
                          />
                        </div>
                        <ul className="instant-help-ul">
                          <li>
                            Make sure the following details are clear on your
                            pan card
                          </li>
                        </ul>
                        <div className="nested-list instant-help-ul">
                          <ul>
                            <li>
                              Always upload Original or Colored Scanned Pan Card
                              Image
                            </li>
                            <li>PAN card number</li>
                            <li>Date of birth</li>
                            <li>Photo</li>
                          </ul>
                        </div> */}
                      </div>
                    </div>
                  </InfoModal>
                </div>
              ) : (
                ""
              )}
              <div className="fixed-card">
                {/* <div style={{ float: "left", width: "70%" }}>
                  <h4> Can't see your face?</h4>
                </div> */}
                <div style={{ float: "left", width: "30%" }}>
                  <button
                    ref={triggerRef}
                    type="button"
                    className={`instant-help-button ${
                      instantHelpReadMoreFlag ? "color-red" : "color-blue"
                    }`}
                    onClick={readMoreFlagToggle}
                    aria-expanded={instantHelpReadMoreFlag}
                    aria-label="Instant help"
                    aria-controls="instant-help-mobile-dialog"
                  >
                    ? instant help!!
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className={"chatText card " + props.className}>
              {instantHelpReadMoreFlag ? (
                <div
                  className="f-modal"
                  role="dialog"
                  aria-modal="true"
                  aria-label="Instant Help"
                  id="instant-help-desktop-dialog"
                >
                  <div className="f-modal-content">
                    <div className="" style={{ padding: "8px" }}>
                      <div style={{ marginBottom: "28px" }}>
                        <div
                          className=""
                          style={{ float: "left", width: "95%" }}
                        >
                          <h2
                            className="blue text-center"
                            style={{ color: "#434343" }}
                          >
                            Instant Help!!!
                          </h2>
                        </div>
                        <button
                          ref={closeBtnRef}
                          type="button"
                          className="instant-help-close-btn"
                          aria-label="Close instant help"
                          onClick={readMoreFlagToggle}
                        >
                          x
                        </button>
                      </div>
                      <div className="instant-help-body">
                        <p>
                        We hope you're ready to begin your onboarding journey
                        with us using your PAN Card. Follow these simple steps
                        to ensure a smooth process:
                        </p>
                        <h3>Are you handy with your PAN Card:</h3>
                        <ul className="instant-help-ul">
                          <li>Have your PAN card handy.</li>
                          <li>
                            Make sure to upload it in a horizontal format for
                            clear visibility, as it will be shared with the KYC
                            Registration Agency (KRA) if not KRA.
                          </li>
                        </ul>
                        <h3>Why do we require PAN Card?</h3>
                        <p className="instant-help-note">
                           Your PAN card is needed to verify your name with
                          the Income Tax website.
                        </p>
                        <h3> How to Upload a PAN Card?</h3>
                        <ul className="instant-help-ul">
                          <li>
                            Upload a color image copy of your PAN card, ensure
                            that it is properly cropped in a horizontal format.
                          </li>
                          <li>
                            Our system will automatically read and fill in your
                            First Name, Middle Name, Last Name, Date of Birth,
                            and PAN Card Number.
                          </li>
                          <li>
                            If any information is incorrect, you can edit it
                            before submitting.
                          </li>
                        </ul>
                        <h3>Information Verification:</h3>
                        <p>
                          The data will be sent to the Income Tax Department for
                          verification. Verification is necessary to open your
                          account.
                        </p>
                        <p>Handling Name Mismatch Errors:</p>
                        <ul className="instant-help-ul">
                          <li>
                            If you get a "Name not Matched" error, you can
                            verify your name using this link:{" "}
                            <a
                              href="https://eportal.incometax.gov.in/iec/foservices/#/pre-login/verifyYourPAN"
                              target="_blank"
                            >
                              Verify Your PAN
                            </a>
                          </li>
                          <li>
                            {" "}
                            Enter the Name as per Aadhar / Bank / Name that you
                            have entered while entering PAN Card.
                          </li>
                        </ul>
                        <p>
                           Note: This may happen only if you have changed your
                          Name Post Marriage or Pan Card is issued prior to 2012
                          as per Income Tax Authorities.
                        </p>
                        <h3>Tips for Smooth Processing:</h3>
                        <ul>
                          <li>
                            Always upload the original or a colour scanned image
                            of your PAN card.
                          </li>
                          <li>
                            Ensure that the Name, Date of Birth, and Photo on
                            your PAN card are clearly visible.
                          </li>
                        </ul>
                        {/* <div className="text-center">
                          <img
                            className="pan_image_sample"
                            src={PanSample}
                            alt={"pan-sample"}
                          />
                        </div>
                        <ul className="instant-help-ul">
                          <li>
                            Make sure the following details are clear on your
                            pan card
                          </li>
                        </ul>
                        <div className="nested-list instant-help-ul">
                          <ul>
                            <li>
                              Always upload Original or Colored Scanned Pan Card
                              Image
                            </li>
                            <li>PAN card number</li>
                            <li>Date of birth</li>
                            <li>Photo</li>
                          </ul>
                        </div> */}
                      </div>
                      {/* <p>
                        We hope you're ready to begin your onboarding journey
                        with us using your PAN Card. Follow these simple steps
                        to ensure a smooth process:
                        <ul className="instant-help-ul">
                          <li>Click on selfie console</li>
                          <li>
                            You will be prompted to give access to your camera
                            and location-allow when asked.
                          </li>
                          <li>
                            If your laptop or desktop doesn't have a camera
                            don't worry! Enable the toggle button below the
                            selfie console and you'll get a link to your selfie
                            via SMS on your registered mobile device.
                          </li>
                          <li>
                            Enter your PAN and Aadhaar details to validate your
                            PAN-Aadhaar seeding check.
                          </li>
                          <li>
                            Remember to keep your PAN card handy. You'll need to
                            upload it in horizontal format so that it's clear
                            and can be shared with KRA.
                          </li>
                        </ul>
                        <div className="text-center">
                          <img
                            className="pan_image_sample"
                            src={PanSample}
                            alt={"pan-sample"}
                          />
                        </div>
                        <ul>
                          <li>
                            Make sure the following details are clear on your
                            pan card
                          </li>
                        </ul>
                        <div className="nested-list instant-help-ul">
                          <ul>
                            <li>
                              Always upload Original or Colored Scanned Pan Card
                              Image
                            </li>
                            <li>PAN card number</li>
                            <li>Date of birth</li>
                            <li>Photo</li>
                          </ul>
                        </div>
                      </p> */}
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              <h2 className="blue">Instant Help!!!</h2>

              <p>
                We hope you're ready to begin your onboarding journey with us
                using your PAN Card. Follow these simple steps to ensure a
                smooth process.
              </p>

              <button
                ref={triggerRef}
                type="button"
                className="blue cursor-pointer readMoreBtn"
                onClick={readMoreFlagToggle}
                aria-expanded={instantHelpReadMoreFlag}
                aria-controls="instant-help-desktop-dialog"
                aria-label="Read more about Instant Help"
              >
                Read More
              </button>
            </div>
          )}
        </div>
      ) : (
        <div>
          {DeviceContext().isMobile ? (
            <div className="tooltip">
              <div className="callIcon">
                <span>
                  <img src={callSupport} alt="Call Support" />
                </span>
              </div>
              <div className="callText">Call</div>
              <div className="tooltiptext">
                <p>
                  <a href="tel:18001023335" className="blue" style={{ textDecoration: "underline" }}>
                    1800 102 3335
                  </a>
                </p>
                <p>Monday to Saturday : 10:00 AM - 6:00 PM</p>
                {/* <p>Saturday 10 AM - 4 PM</p> */}
              </div>
            </div>
          ) : (
            <div className={"chatText " + props.className}>
              <p>For any queries contact us:</p>
              <p>
                <a href="tel:18001023335" className="blue">
                  1800 102 3335
                </a>
              </p>
              <p>*Weekdays 10:00 AM - 6:00 PM</p>
              <p>*Saturday 10:00 AM - 5:00 PM</p>
              <p>(*Except on 1st Saturday and Trading Holidays.)</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default ChatText;